import Label from "@ingka/label";
import { Select, Option } from "@ingka/select";
import FormField from "@ingka/form-field";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  options: Record<string, string>;
  disabled: boolean;
};

const Launch = ({ options, disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("launch", activeAsset.id!);
  const isUpdating = isMetadataUpdating(activeAsset.id!, "launch");
  return (
    <>
      <Label
        htmlFor="launch"
        label={
          <LabelWithToolTip
            labelText="Launch"
            toolTipText="Choose the appropriate launch for when the assets are planned to be used. Note that the launch is not connected to usage rights, and is in no way limiting the usage to a specific launch."
          />
        }
      />
      <FormField
        valid="error"
        validation={{
          msg: error?.message,
          type: "error",
        }}
        shouldValidate={Boolean(error)}
      >
        <Select
          id="launch"
          value={activeAsset.launch || ""}
          disabled={disabled || isUpdating}
          onChange={(e) => {
            updateMetadata({
              launch: e.target.value,
            });
          }}
        >
          {Object.entries(options).map(([name, label]) => (
            <Option key={name} name={label} value={name} />
          ))}
        </Select>
      </FormField>
    </>
  );
};

export default Launch;
